<template>
  <div class="client_request_activation">
    <div class="header">
      <h4 class="title">
        {{ translate("client_request.activation")}}
        {{ device_fid }}
        ({{ device_name }})
      </h4>
    </div>
    <div class="content">

      <div class="line">
        <fg-input
            type="number"
            :min=0
            :max=8
            v-model="activate_data.sim_count"
            :placeholder="translate('client_request.count_simcard')"
            :label="translate('client_request.count_simcard')"
            @input.native="check_sim_count"
        />

        <div class="form-group">
          <label> {{ translate('client_request.width_channel') }} </label>
          <input
              type="number"
              class="form-control border-input error"
              v-model="activate_data.bandwidth"
              :placeholder="translate('client_request.width_channel')"
              @input="validateInput"
          >
        </div>
      </div>

      <div class="line" >
        <fg-input
            v-if="initiator_label"
            type="text"
            v-model="activate_data.initiator_id"
            :placeholder="initiator_label"
            :label="initiator_label"
        />

        <div class="form-group filter checkbox" v-if="$store.getters.getPermissions.permissionGod === true">
          <div class="info">
            {{ translate('client_request.mark_in_work') }}
          </div>
          <label
              class="switch"
              @click.prevent="activate_data.mark_in_work = !activate_data.mark_in_work"
          >
            <input type="checkbox" v-model="activate_data.mark_in_work" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="line">
        <fg-input
            type="text"
            v-model="activate_data.notification_emails"
            :placeholder="translate('client_request.email_notification')"
            :label="translate('client_request.email_notification')"
        />
      </div>

      <div class="line text_wrap">
        <div class="form-group">
          <label> {{ translate('client_request.comment') }} </label>
          <textarea class="input_text" name="comment" v-model="activate_data.comment" rows="3" />
        </div>
      </div>
    </div>

    <div class="footer">
      <span
          class="btn btn-success btn-fill btn-wd marginButton"
          @click.prevent="activate"
      >
        {{ translate('btn.activate') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </span>
    </div>
  </div>

</template>
<script>

export default {
  name: "ClientRequestDeviceActivation",
  props: [
    "device_fid",
    "device_id",
    "device_name",
    "initiator_label"
  ],
  data () {
    return {
      activate_data: {
        sim_count: null,
        bandwidth: "",
        comment: "",
        initiator_id: null,
        mark_in_work: false,
        notification_emails: ""
      },
    }
  },

  methods: {
    check_sim_count(e) {
      const value = Math.min(8, Math.max(0, Number(e.target.value)))

      e.target.value = value
      this.activate_data.sim_count = value
    },
    validateInput(e) {
      this.activate_data.bandwidth = this.activate_data.bandwidth.slice(0, 3)
    },
    cancel () {
      this.$emit('close')
    },
    activate(){
      let data = {...this.activate_data}
      data.device_id = this.device_id
      data.bandwidth = Number(data.bandwidth)
      data.sim_count = Number(data.sim_count)
      if (data.initiator_id === null || data.initiator_id === "") delete data.initiator_id

      this.$http.v1.activateDeviceClientRequestList(data, (response) => {
        this.global_notify("info", this.translate("client_request.request_created"));
        this.$emit("update")
      })
    }
  }
}

</script>

<style lang='scss' scoped>
  .client_request_activation{
    padding: 10px;
    .header{
      padding: 10px 0;
      .title{
        font-size: 22px;
        font-weight: 600;
        margin: 0;
        text-align: center;
      }
    }
    .content{
      padding: 10px 0;

      .line{
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        .form-group{
          width: 100%;
          margin-right: 10px;
          &:last-child{
            margin-right: 0;
          }
        }
      }

    }
    .footer{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        margin: 0 5px;
        display: block;
      }
    }
  }

</style>
